import React, { Component } from 'react';

export class Home extends Component {

  constructor(props) {
    super(props);
    this.state = { redirect: false };
  }

  componentWillMount() {
  }

  render() {
    return (
      <div className="EBaoHome__Container" />
    )
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/app/pages/Home.js